import React, { useState } from "react";
import Layout from "../../Layout/Layout";
import MainContent from "./MainContent/MainContent";
import ChatsSection from "./ChatsSection/ChatsSection";
import GroupSection from "./GroupSection/GroupSection";
import CreateChannelScreen from "./CreateChannelScreen/CreateChannelScreen";

export default function Channels() {
  const [showGroupSection, setShowGroupSection] = useState(false);
  const [isNewChannel, setIsNewChannel] = useState(false);

  return (
    <Layout
      showGroupSection={showGroupSection}
      setShowGroupSection={setShowGroupSection}
      isNewChannel={isNewChannel}
      setIsNewChannel={setIsNewChannel}
    />
  );
}
